/* eslint-disable */

import React, {FC} from "react";
import {Card, Grid, Tooltip, Typography, withStyles} from "@material-ui/core";
import cashUtilities from "../../../../../assets/icons/porcentajesUtilidadesIcon.svg";
import {useStyles} from "../../style";
import Chart from "react-apexcharts";
import { margin, style } from "@material-ui/system";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const UtilitiesRadialBars: FC<any> = (props) => {
    const classes = useStyles();
    const { header, tableData } = props.data;
    //const header = [`Utilidad Bruta (GI)`, "Utilidad Bruta (EBITDA)", "Utilidad Bruta (EBIT)", "Utilidad Despues de Intereses (EBT)", "Utilidad Despues de Impuestos (EB)", "Utilidad Neta (NI)"]
    //const auxHeader = [`Utilidad Bruta (GI)(44%)`, "Utilidad Bruta (EBITDA)(-55%)", "Utilidad Bruta (EBIT)(68%)", "Utilidad Despues de Intereses (EBT)(83%)", "Utilidad Despues de Impuestos (EB)(-89%)", "Utilidad Neta (NI)(91%)"]
    const auxHeader = header.map((e,i) => `${e} (${tableData[i]}%)`)


    //const tableData = [44, -55, 68, 83, -89, 91]
    const allNegatives = []
    



    const auxTableData = tableData.map((v,i) => {
        if(v < 0){
            allNegatives.push(i)
            return v * -1
        }
        return v
    })
    const palette = ['#A8D0E6','#B0D9E7','#C0E0EF','#D0E8F2','#E0F0F5','#90C1D4'];

    for (let i = 0; i < allNegatives.length; i++) {
        const index = allNegatives[i];
        palette[index] = "#F8D57E"

    }



    const chartData = {
        series: auxTableData,
        options: {
            colors: palette,
            chart: {
                height: 350,
                type: 'radialBar',
            },

            plotOptions: {
                radialBar: {
                    offsetY: 0,
                    startAngle: 0,
                    // endAngle: 270,
                    hollow: {
                        margin: 5,
                        size: '30%',
                        background: 'transparent',
                        image: undefined,
                    },
                    dataLabels: {
                        style: {margin: '20px'},
                        enabled: true,
                        name: {
                            fontSize: '1.2rem',
                            offsetY: -190,
                            color: "#034886",
                        },
                        value: {
                            fontSize: '24px',
                            offsetY: -10,
                            fontWeight: 800,
                            formatter: function (val, opts) {
                            return ""
                         },

                        },

                        total: {
                            show: false,
                        },

                        





                    },

                }
            },
            labels: auxHeader,
        },
    }

    return (
        <Grid component={Card} padding={9}>
            <Grid className={classes.chartLineBarsBox} item xs={12} md={12} marginBottom={5}>
                <div>
                    <img src={cashUtilities} alt="roundWorkHistory" width="35px" height="35px"/>
                </div>
                <Typography  className={classes.utilitiesRadialBarText} paddingLeft={2}>
                    Porcentaje de Utilidades
                </Typography>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} md={7} height={450}>
                    <div></div>
                    <Chart
                        options={chartData.options}
                        series={chartData.series}
                        type="radialBar"
                        width='100%'
                        height='100%'
                    />
                </Grid>
                <Grid item paddingLeft='0px!important' xs={12} md={5}>
                    {header.map((item, index) => (
                        <>
                            <Grid item pl={0} display="flex" justifyContent="space-between">
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div style={{height: '10px', width: '10px',marginRight:'5px', backgroundColor: palette[index]}}></div>
                                    <Typography className={classes.chartBarLineText}>{item}</Typography>
                                </div>
                            <Typography className={classes.chartBarDonutText}>{tableData[index]}%</Typography>
                            </Grid>
                        </>
                    ))}
                </Grid>
            </Grid>
            
        </Grid>
    )
};

export default UtilitiesRadialBars;